import React, { FC, HTMLAttributes } from 'react';
import DetailNav from '../DetailNav/DetailNav';
import Brand from '../Brand/Brand';
import styles from './NavBrand.module.scss';
import { useQuery } from '@redux-requests/react';
import { AppsConstants } from 'modules/userApps/store/constants';
import classNames from 'classnames';

export interface INavBrand extends HTMLAttributes<HTMLDivElement> {
  id: string;
}

const NavBrand: FC<INavBrand> = (props) => {
  const { id, className } = props;
  const {
    data: { name, imageUrl },
  } = useQuery({ type: AppsConstants.APP, requestKey: id });
  const rootClassName = classNames(styles.root, className);

  return (
    <div className={rootClassName}>
      <Brand title={name} subtitle='TIMIFY Scheduling Software' logo={imageUrl} className='mr-1' />
      <DetailNav className={styles.nav} />
    </div>
  );
};

export default NavBrand;
